<template>
  <el-card class="box-card">
    <div class="main">
      <el-form ref="searchInfo" :model="info" class="global-form" :inline="true">
        <el-form-item prop="detailedType">
          <el-select v-model="info.detailedType" placeholder="请选择业务类型" filterable clearable>
            <el-option v-for="(item, index) in businessType" :label="item" :value="(index + 1).toString()" :key="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="projectId">
          <el-select v-model="info.projectId" placeholder="请选择项目" filterable @change="getWareHouseList" clearable>
            <el-option v-for="(item, index) in projectList" :label="item.projectName" :value="item.projectId"
              :key="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="warehouseId">
          <el-select v-model="info.warehouseId" placeholder="请选择仓库" filterable clearable>
            <el-option v-for="(item, index) in wareHouseList" :label="item.warehouseName" :value="item.warehouseId"
              :key="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="materialTypeId">
          <el-cascader v-model="info.materialTypeId" :options="materialTypeData" :props="{
            checkStrictly: true,
            emitPath: false,
            children: 'childNode',
            label: 'materialTypeName',
            value: 'materialTypeId',
          }" placeholder="请选择物料分类" clearable></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="dateRange" type="daterange" range-separator="-" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="materialName">
          <el-input v-model="info.materialName" placeholder="请输入物料名称" clearable></el-input>
        </el-form-item>
        <el-form-item prop="detailedNum">
          <el-input v-model="info.detailedNum" placeholder="请输入单据号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <!-- v-show="$ButtonShow('YDD_SEL_06')" -->
          <CustomExport type="11" :params="{ ...info }" v-show="$ButtonShow('YDD_SEL_06')">导出</CustomExport>
        </el-form-item>
      </el-form>
      <el-table class="global-table" v-loading="tableData.loading" :data="tableData.data">
        <el-table-column min-width="100" showOverflowTooltip label="业务类型" prop="detailedType">
          <template v-slot="{ row }">
            {{ businessType[+row.detailedType - 1] }}
          </template>
        </el-table-column>
        <el-table-column min-width="100" showOverflowTooltip label="单据号" prop="detailedNum"></el-table-column>
        <el-table-column min-width="100" showOverflowTooltip label="单据创建时间" prop="ctime"></el-table-column>
        <el-table-column min-width="100" showOverflowTooltip label="项目名称" prop="projectName"></el-table-column>
        <el-table-column min-width="100" showOverflowTooltip label="仓库" prop="warehouseName"></el-table-column>
        <el-table-column min-width="100" showOverflowTooltip label="物料分类" prop="materialTypeName"></el-table-column>
        <el-table-column min-width="100" showOverflowTooltip label="物料名称" prop="materialName"></el-table-column>
        <el-table-column min-width="100" showOverflowTooltip label="规格型号" prop="specifications"></el-table-column>
        <el-table-column min-width="100" showOverflowTooltip label="品牌名称" prop="brand"></el-table-column>
        <el-table-column min-width="100" showOverflowTooltip label="数量" prop="operationStock"></el-table-column>
        <el-table-column min-width="100" showOverflowTooltip label="结存库存" prop="afterStock"></el-table-column>
      </el-table>
      <global-pagination @size-change="getData" @current-change="getData" :current-page.sync="page"
        :page-size.sync="size" :total="total">
      </global-pagination>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "FlowList",
  components: {},
  data() {
    return {
      // 业务类型
      businessType: ["入库", "出库"],
      // 仓库
      wareHouseList: [],
      // 物料分类
      materialTypeData: [],
      info: {
        // 业务类型
        detailedType: "",
        // 项目
        projectId: "",
        // 仓库
        warehouseId: "",
        // 物料分类
        materialTypeId: "",
        // 物料名称
        material: "",
        // 单号
        detailedNum: "",
      },
      dateRange: [],
      tableData: {
        loading: false,
        data: [],
      },
      page: 1,
      size: 10,
      total: 0,
    };
  },
  computed: {
    projectList() {
      return this.$store.state.projectList;
    },
  },
  watch: {},
  created() {
    this.getData();
    this.loadMaterialType(); // 物料类型
  },
  methods: {
    loadMaterialType() {
      this.$axios
        .get(this.$apis.material.selectYhMaterialTypeByList).then((res) => {
          this.materialTypeData = res || [];
        });
    },
    getData() {
      console.log(
        "this.$apis.material.selectYhDetailedByPage",
        this.$apis.material.selectYhDetailedByPage
      );
      this.tableData.loading = true;
      this.$axios
        .get(this.$apis.material.selectYhDetailedByPage, {
          ...this.info,
          startTime: this.dateRange ? this.dateRange[0] || "" : "",
          endTime: this.dateRange ? this.dateRange[1] || "" : "",
          page: this.page,
          size: this.size,
        })
        .then((res) => {
          this.total = res.total || 0;
          this.tableData.data = res.list || [];
        })
        .finally(() => {
          this.tableData.loading = false;
        });
    },
    // 仓库
    getWareHouseList() {
      this.info.warehouseId = "";
      this.$axios
        .get(this.$apis.material.selectYhWarehouseByList, {
          projectId: this.info.projectId,
        })
        .then((res) => {
          this.wareHouseList = res.list || [];
        });
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
  },
};
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  padding: 0px 10px;
}
</style>
